import React from "react";
import { Trans } from "@lingui/macro";

export const SessionModalTitle = <Trans id="sessionModal.title">Session Expiration</Trans>;
export const SessionModalBtnContinue = (
  <Trans id="sessionModal.action.continue.title">Continue</Trans>
);
export const SessionModalBtnLogOut = <Trans id="sessionModal.action.logOut.title">Log Out</Trans>;
